import { QueryString } from "./QueryString";
import { Id_category, Id_floor, Id_drawing, Id_building } from "./api/Identifiers";
import { exists } from "./utils";



/**
 * These configuration parameters are effective on app startup and are pulled 
 * from the querystring. They should NOT change while CMS View is running.
 */

export class Configuration {
    public static get read_only_mode(): boolean {
        return QueryString.is_read_only;
    }

    public static get findings_feature_enabled(): boolean {
        let parent_app: string = QueryString.parent_app;
        if (parent_app === QueryString.VALUE_CMS_TECH) {
            return false;
        }
        if (parent_app === QueryString.VALUE_CMS_SURVEYOR) {
            return false;
        }
        return true;
    }

    public static get assets_feature_enabled(): boolean {
        let parent_app: string = QueryString.parent_app;
        if (this.is_cms_rounding) {
            return false;
        }
        return true;
    }

    public static get is_prod():boolean{
        return ((QueryString.parent_app =="prod") || (QueryString.parent_app == null));
    }

//     public static get rpt_feature_enabled(): boolean {
//         // AWH TODO: check that build is not prod
//         return ((Configuration.is_cms_tech) && (!Configuration.is_prod))
// //        return ((QueryString.customer_name=="cms-test1") || (QueryString.customer_name=="osuwmc") || (QueryString.customer_name=="ohiohealth"))
//     }

    public static get workorders_feature_enabled(): boolean {
        let parent_app: string = QueryString.parent_app;
        if (this.is_cms_rounding) {
            return false;
        }
        if (parent_app === QueryString.VALUE_CMS_SURVEYOR) {
            return false;
        }
        return true;
    }

    public static get attachments_feature_enabled(): boolean {
        return Configuration.workorders_feature_enabled;
    }

    public static get spotshadow_feature_enabled(): boolean {
        return Configuration.is_cms_tech;
    }

    public static get buildings_feature_enabled(): boolean {
        return true;
    }

    public static get floors_feature_enabled(): boolean {
        return true;
    }

    public static get building_workorder_count_feature_enabled(): boolean {
        return true;
    }

    public static get database_name(): string {
        return QueryString.customer_name;
    }

    public static get filter_finding_id_category(): Id_category {
        return QueryString.filter_finding_id_category;
    }

    public static get is_decluster_enabled(): boolean {
        return false;
    }

    public static get is_cms_surveyor(): boolean {
        return  QueryString.parent_app === "cms_surveyor";
    }

    public static get is_cms_rounding(): boolean {
        let parent_app: string = QueryString.parent_app;
        if (parent_app === QueryString.VALUE_CMS_ROUNDING) {
            return true;
        }
        if (parent_app === "eoc") {
            return true;
        }
        let url: string = window.location.href;
        if (url.startsWith("https://eocview")){
            return true;
        }
        return false;
    }

    public static get is_cms_tech(): boolean {
        let parent_app: string = QueryString.parent_app;
        if (!exists(parent_app)){
            if(!Configuration.is_cms_rounding){
                if(!Configuration.is_cms_surveyor){
                    return true; // if no parent app value is passed, assume the 
                }
            }
        }
        if (parent_app === QueryString.VALUE_CMS_TECH) {
            return true;
        }
        // let url: string = window.location.href;
        // if (url.startsWith("https://eocview")){
        //     return true;
        // }
        return false;

    }

    public static get initial_id_floor(): Id_floor | null{
        return QueryString.id_floor;
    }

    public static get initial_id_building(): Id_building | null{
        return QueryString.id_building;
    }

    public static get initial_id_drawing(): Id_drawing | null{
        return QueryString.id_drawing;
    }

    public static get floorplan_api_gateway():string{
        if (QueryString.use_ngrok){
            return "https://drawings-pipeline.ngrok.io"
        }
        // if the floorplan_api_gateway is passed in via the querystring, return the overridden value
        if (exists(QueryString.floorplan_api_gateway) ){
            return QueryString.floorplan_api_gateway;
        }
        // otherwise, derive it from the cmstech api gateway
        let api_gateway=QueryString.api_gateway
        if (exists(api_gateway) ){
            if (api_gateway.startsWith("https://cmsapi-dev.facsur.com")){
                return "https://floorplanapi-dev.facsur.com"
            }
            if (api_gateway.startsWith("https://cmsapi-test.facsur.com")){
                return "https://floorplanapi-test.facsur.com"
            }
            if (api_gateway.startsWith("https://cmsapi.facsur.com")){
                return "https://floorplanapi.facsur.com"
            }
            // if (api_gateway.startsWith("https://eocapi-dev.facsur.com")){
            //     return "https://floorplanapi-dev.facsur.com"
            // }
            // if (api_gateway.startsWith("https://eocapi-test.facsur.com")){
            //     return "https://floorplanapi-test.facsur.com"
            // }
            // if (api_gateway.startsWith("https://eocapi.facsur.com")){
            //     return "https://floorplanapi.facsur.com"
            // }
            console.error(`Could not derive a floorplanapi gateway from ${api_gateway}`)
        }
        return "https://floorplanapi.facsur.com"
    }

    public static get isPdfPrint():boolean{
        let isPdfPrint : boolean = false;
        if (this.database_name == "cms-test1" || this.database_name == "medxcel" || this.database_name == "medxcel-test"){
            isPdfPrint = true;
        }
        return isPdfPrint;
    }

}



// WEBPACK FOOTER //
// ./src/ts/Configuration.ts